<template>
<div>
    <Breadcrumbs main="Admin" submain="Portfolio" title="Newspaper Publications" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                            <i class="fa fa-light fa-plus"></i>
                            <h7>Add New Newspaper Publication</h7>
                        </button>
                    </div>

                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <b-input-group class="datatable-btn">
                                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="blog_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(image)="row">
                                        <img :src="host + row.item.image" alt="" style="width: 120px; height: 80px;">
                                    </template>

                                    <template #cell(title)="row">
                                        <div v-if="row.item.title">
                                            <p>{{ row.item.title }}</p>
                                        </div>
                                    </template>

                                    <template #cell(source)="row">
                                        <div v-if="row.item.source">
                                            <p>{{ row.item.source }}</p>
                                        </div>
                                    </template>

                                    <!-- <template #cell(link)="row">
                                        <div v-if="row.item.link">
                                            <a :href="row.item.link" target="_blank" class="link-style">{{ row.item.link.substring(0,40) }}</a>
                                        </div>
                                        <div v-else>
                                            N/A
                                        </div>
                                    </template> -->

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <div>
                                                <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteBlog(data.item.id)" title="Delete"></feather>
                                            </div>
                                            <div @click="editBlog(data.item)">
                                                <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                            </div>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- BLog Create Modal -->
    <b-modal id="modal-prevent-closing" ref="modal" title="Add Newspaper Publication" size="xl" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit()">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" placeholder="Enter blog title" v-model="blog.title">
                    </div>
                </div>
            </div>
           
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Source</label>
                        <input class="form-control" type="text" placeholder="Enter blog source" v-model="blog.source">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Link</label>
                        <input class="form-control" type="text" placeholder="Enter link URL" v-model="blog.link">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Description</label>
                        <!-- <ckeditor :editor="editor" placeholder="Enter description..." v-model="blog.description"></ckeditor>  -->
                        <vue-editor v-model="blog.description"></vue-editor>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Image</label>
                        <div class="flex items-center">
                            <img v-if="show_image" style="width: 120px; height: 80px;" :src="show_image">
                            <input :class="blog.image ? 'ml-4' : 'ml-0'" type="file" accept="image/*" @change="uploadFile">
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Blog Edit Modal -->
    <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Newspaper Publications" size="xl" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
        <form ref="form" @submit.stop.prevent="handleEditSubmit">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" placeholder="Enter title" v-model="edit_blog.title">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Source</label>
                        <input class="form-control" type="text" placeholder="Enter blog source" v-model="edit_blog.source">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Link</label>
                        <input class="form-control" type="text" placeholder="Enter link URL" v-model="edit_blog.link">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Description</label>
                        <!-- <ckeditor :editor="editor" placeholder="Enter description..." v-model="edit_blog.description"></ckeditor> -->
                        <vue-editor v-model="edit_blog.description"></vue-editor>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Image</label>
                        <div class="flex items-center">
                            <img v-if="show_image" style="width: 120px; height: 80px;" :src="show_image">
                            <input :class="edit_blog.image ? 'ml-4' : 'ml-4'" type="file" accept="image/*" @change="EdituploadFile">
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Gallery Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this opinion?</div>
    </b-modal>
</div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Datepicker from 'vuejs-datepicker';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import moment from "moment";
import { mapState } from 'vuex';
import { myHost } from '../../../_helpers/host';
import js from '../../../auth/js';
import loader from '../loader/loader.vue';
import { VueEditor } from "vue2-editor";

export default {
    components: {
        Datepicker,
        loader,
        VueEditor
    },

    data() {
        return {
            editor: ClassicEditor,
            host: myHost.host,
            tablefields: [
                {
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'image',
                    label: 'Image',
                    sortable: true
                },
                {
                    key: 'title',
                    label: 'Title',
                    sortable: true
                },
                {
                    key: 'source',
                    label: 'Source',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],

            blog: {
                title: '',
                description: '',
                image: null,
                link: '',
                source: ''
            },

            edit_blog: {
                id: '',
                title: '',
                description: '',
                image: null,
                link: '',
                source: ''
            },

            show_image: null,
            delete_value: null,

            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15]
        };
    },

    computed: {
        ...mapState({
            blog_list: state => state.blog.blog,
            loading: state => state.blog.blogLoading,
            error: state => state.blog.blogError
        }),

        sortOptions() {
            // Create an options list from our fields
            return this.tablefields
            .filter(f => f.sortable)
            .map(f => {
                return {
                    text: f.label,
                    value: f.key
                };
            });
        }
    },

    mounted() {
        this.$store.dispatch("blog/fetchBlog").then(() => {
            this.items = this.blog_list
            this.totalRows = this.items.length;
        });
    },

    methods: {
        uploadFile(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.show_image = e.target.result
                this.blog.image = e.target.result;
            };
        },

        EdituploadFile(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.show_image = e.target.result
                this.edit_blog.image = e.target.result;
            };
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        resetModal() {
            this.blog.title = null
            this.blog.image = null
            this.blog.description = null
            this.blog.link = null
            this.blog.source = null
            this.show_image = null
            this.blog.image = null
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleSubmit() {
            this.$store.dispatch("blog/addBlog", {
                blog: this.blog
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.blog.title = null,
                    this.blog.description = null,
                    this.blog.image = null,
                    this.show_image = null,
                    this.blog.link = null
                    this.blog.source = null
                    this.blog.image = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },

        editBlog(detail) {
            this.edit_blog.id = detail.id ? detail.id : null
            this.edit_blog.title = detail.title ? detail.title : null
            this.edit_blog.description = detail.description ? detail.description : null
            this.edit_blog.link = detail.link ? detail.link : null
            this.edit_blog.source = detail.source ? detail.source : null
            this.show_image = detail.image ? this.host + detail.image : null
        },

        resetEditModal() {
            this.edit_blog.title = null
            this.edit_blog.description = null
            this.edit_blog.image = null,
            this.edit_blog.link = null
            this.edit_blog.source = null
            this.show_image = null
            this.edit_blog.image = null
        },

        handleEditOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleEditSubmit()
        },

        handleEditSubmit() {
            this.$store.dispatch("blog/updateBlog", {
                id: this.edit_blog.id,
                blog: this.edit_blog,
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.edit_blog.title = null
                    this.edit_blog.description = null
                    this.edit_blog.image = null
                    this.edit_blog.link = null
                    this.edit_blog.source = null
                    this.show_image = null
                    this.edit_blog.image = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-edit')
            })
        },

        deleteBlog(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("blog/deleteBlog", {
                delete: this.delete_value
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>
